import { BrowserRouter, HashRouter } from "react-router-dom";
import WebRouter from "./webRouter.jsx";

const Router = () => {
  return (
    <HashRouter>
      <WebRouter />
    </HashRouter>
  );
};

export default Router;
